import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.title',
		defaultMessage: 'Introducing project summary {sparklesIcon}',
		description: 'Title of the project summary onboarding',
	},
	adminBody: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.admin-body',
		defaultMessage:
			'View a dashboard with key metrics and charts to gain insights into your team’s work.',
		description: 'Body of the project summary onboarding for admins',
	},
	dismissButtonText: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.dismiss-button-text',
		defaultMessage: 'Dismiss',
		description: 'Text for the dismiss button',
	},
	enableButtonText: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.enable-button-text',
		defaultMessage: 'Enable project summary',
		description: 'Text for the enable button',
	},
	readMoreLink: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.read-more-link',
		defaultMessage: 'Read more about project summary.',
		description: 'Text for the read more link',
	},
	toggleFeatureSuccessFlagTitle: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.toggle-feature-success-flag-title',
		defaultMessage: 'Project summary page enabled',
		description: 'Title on success flag when toggle feature on',
	},
	toggleFeatureSuccessFlagDescription: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.toggle-feature-success-flag-description',
		defaultMessage:
			'You can disable this again at any time from <b>Features</b> in project settings.',
		description: 'Description on success flag when toggle feature on',
	},
	toggleFeatureErrorFlagTitle: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.toggle-feature-error-flag-title',
		defaultMessage: "We couldn't enable the project summary page",
		description: 'Title on success flag when toggle feature on',
	},
	toggleFeatureErrorFlagDescription: {
		id: 'servicedesk.queues.agent-view.layout.project-summary-onboarding.toggle-feature-error-flag-description',
		defaultMessage: 'Go to <b>Features</b> in project settings and try again.',
		description: 'Description on success flag when toggle feature on',
	},
});
